<template>
  <div>
    <div v-if="data.dangerous_good_info">
      <div class="has-margin-bottom-20 has-margin-top-20 has-border-bottom">
        <h2
          class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
        >Dangerous Goods Properties</h2>
      </div>
      <div class="columns is-multiline">
        <!-- UN Number -->
        <div class="column is-4" v-if="data.dangerous_good_info.un_number">
          <b-field label="UN Number">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.dangerous_good_info.un_number"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Proper Shipping Name-->
        <div class="column is-8" v-if="data.dangerous_good_info.proper_shipping_name">
          <b-field label="Proper Shipping Name">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.dangerous_good_info.proper_shipping_name"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Chemical Name -->
        <div class="column is-8" v-if="data.chemical_name">
          <b-field label="Chemical Name">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.chemical_name"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Imo Class -->
        <div class="column is-4" v-if="data.dangerous_good_info.imo_class">
          <b-field label="IMO Class">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.dangerous_good_info.imo_class"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Packaging Group -->
        <div class="column is-4" v-if="data.dangerous_good_info.packing_group">
          <b-field label="Packaging Group">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.dangerous_good_info.packing_group"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- IMDG Code Segregation Groups -->
        <div class="column is-4" v-if="data.imdg_code_segregation_group">
          <b-field label="IMDG Code Segregation Group">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.imdg_code_segregation_group"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Sub Risk -->
        <div class="column is-4" v-if="data.sub_risk">
          <b-field label="Sub Risk">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.sub_risk"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Storage Space -->
        <div class="column is-4" v-if="data.dangerous_good_info.storage_state">
          <b-field label="Storage Space">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.dangerous_good_info.storage_state"
              readonly
            ></b-input>
          </b-field>
        </div>
      </div>
      <div class="has-margin-bottom-20 has-margin-top-20 has-border-bottom">
        <h2
          class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
        >Dangerous Good Environmental Risk</h2>
      </div>

      <div class="columns is-multiline">
        <!-- Emergency Temperature -->
        <div class="column is-4" v-if="data.emergency_temperature">
          <b-field label="Emergency Temperature">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.emergency_temperature"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Empty/Laden Tk -->
        <div class="column is-4" v-if="data.empty_laden_tank">
          <b-field label="Empty/Laden Tk">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.empty_laden_tank"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Flash Point -->
        <div class="column is-4" v-if="data.flash_point">
          <b-field label="Flash Point">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.flash_point"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Net Explosive Quantity -->
        <div class="column is-4" v-if="data.net_explosive_quantity">
          <b-field label="Net Explosive Quantity">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.net_explosive_quantity"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Limited Quantity -->
        <div class="column is-4">
          <b-field label="Limited Quantity">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="limitedQuantity"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Marine Pollutant -->
        <div class="column is-4">
          <b-field label="Marine Pollutant">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="marinePollutant"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Temperature Controlled -->
        <div class="column is-4">
          <b-field label="Temperature Controlled">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="temperatureControlled"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Control Temperature -->
        <div class="column is-4" v-if="data.control_temperature">
          <b-field label="Control Temperature">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.control_temperature"
              readonly
            ></b-input>
          </b-field>
        </div>
      </div>

      <div class="has-margin-bottom-20 has-margin-top-20 has-border-bottom">
        <h2
          class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
        >Dangerous Good Container Details</h2>
      </div>
      <div class="columns is-multiline">
        <!-- Tare Mass -->
        <div class="column is-4" v-if="data.tare_mass">
          <b-field label="Tare Mass">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.tare_mass"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Total Gross Mass -->
        <div class="column is-4" v-if="data.tare_mass">
          <b-field label="Total Gross Mass">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.total_gross_mass"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!--Container Identification Number-->
        <div class="column is-4" v-if="data.container_identification_number">
          <b-field label="Container Identification Number">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.container_identification_number"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!--Seal Number-->
        <div class="column is-4" v-if="data.seal_number">
          <b-field label="Seal Number">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.seal_number"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!--Container Type-->
        <div class="column is-4" v-if="data.container_type">
          <b-field label="Container Type">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.container_type"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!--Container Operator-->
        <div class="column is-4" v-if="data.container_operator">
          <b-field label="Container Operator">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.container_operator"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!--Container Size-->
        <div class="column is-4" v-if="data.container_size">
          <b-field label="Container Size">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="data.container_size"
              readonly
            ></b-input>
          </b-field>
        </div>
      </div>

      <!-- dangerous Good Info ID
      <div class="column is-4" v-if="data.dangerous_good_info.id">
        <b-field label="Updated At">
          <b-input custom-class="has-text-weight-bold is-uppercase" v-model="data.dangerous_good_info.id" readonly></b-input>
        </b-field>
      </div>
      -->

      <div v-for="(dg_packaging, index) in dangerousGoodPackaging" :key="index">
        <dangerous-good-packaging :data="dg_packaging"></dangerous-good-packaging>
      </div>
    </div>

    <!-- Summary of the request -->

    <div v-else>
      <div class="has-margin-bottom-40 has-margin-top-50 has-border-bottom">
        <h2
          class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
        >Dangerous Good Properties</h2>
      </div>
      <div class="columns is-multiline">
        <!-- UN Number -->
        <div class="column is-4" v-if="selectedDangerousGoodInfo">
          <b-field label="UN Number">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="selectedDangerousGoodInfo.un_number"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Proper Shipping Name-->
        <div class="column is-4" v-if="selectedDangerousGoodInfo">
          <b-field label="Proper Shipping Name">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="selectedDangerousGoodInfo.proper_shipping_name"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Chemical Name -->
        <div class="column is-4" v-if="summaryData.chemical_name">
          <b-field label="Chemical Name">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.chemical_name"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Imo Class -->
        <div class="column is-4" v-if="selectedDangerousGoodInfo">
          <b-field label="IMO Class">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="selectedDangerousGoodInfo.imo_class"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Packaging Group -->
        <div class="column is-4" v-if="selectedDangerousGoodInfo">
          <b-field label="Packaging Group">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="selectedDangerousGoodInfo.packing_group"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Sub Risk -->
        <div class="column is-4" v-if="summaryData.sub_risk">
          <b-field label="Sub Risk">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.sub_risk"
              readonly
            ></b-input>
          </b-field>
        </div>
      </div>

      <div class="has-margin-bottom-40 has-margin-top-50 has-border-bottom">
        <h2
          class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
        >Dangerous Good Environmental Risk</h2>
      </div>

      <div class="columns is-multiline">
        <!-- Emergency Temperature -->
        <div class="column is-4" v-if="summaryData.emergency_temperature">
          <b-field label="Emergency Temperature">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.emergency_temperature"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Empty/Laden Tk -->
        <div class="column is-4" v-if="summaryData.empty_laden_tank">
          <b-field label="Empty/Laden Tk">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.empty_laden_tank"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Flash Point -->
        <div class="column is-4" v-if="summaryData.flash_point">
          <b-field label="Flash Point">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.flash_point"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- IMDG Code Segregation Groups -->
        <div class="column is-4" v-if="summaryData.imdg_code_segregation_group">
          <b-field label="IMDG Code Segregation Group">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.imdg_code_segregation_group"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Net Explosive Quantity -->
        <div class="column is-4" v-if="summaryData.net_explosive_quantity">
          <b-field label="Net Explosive Quantity">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.net_explosive_quantity"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Limited Quantity -->
        <div class="column is-4" v-if="summaryData">
          <b-field label="Limited Quantity">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="limitedQuantity"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Marine Pollutant -->
        <div class="column is-4" v-if="summaryData">
          <b-field label="Marine Pollutant">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="marinePollutant"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Temperature Controlled -->
        <div class="column is-4" v-if="summaryData">
          <b-field label="Temperature Controlled">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="temperatureControlled"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Control Temperature -->
        <div class="column is-4" v-if="summaryData.control_temperature">
          <b-field label="Controlled Temperature">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.control_temperature"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- Updated At -->
        <div class="column is-4" v-if="summaryData.updated_at">
          <b-field label="Updated At">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.updated_at"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!-- dangerous Good Info ID
      <div class="column is-4" v-if="data.dangerous_good_info.id">
        <b-field label="Updated At">
          <b-input custom-class="has-text-weight-bold is-uppercase" v-model="data.dangerous_good_info.id" readonly></b-input>
        </b-field>
      </div>
        -->

        <!-- Storage Space -->
        <div class="column is-4" v-if="summaryData.storage_state">
          <b-field label="Storage Space">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.storage_state"
              readonly
            ></b-input>
          </b-field>
        </div>
      </div>

      <div class="has-margin-bottom-40 has-margin-top-50 has-border-bottom">
        <h2
          class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
        >Dangerous Good Container Details</h2>
      </div>

      <div class="columns is-multiline">
        <!-- Tare Mass -->
        <div class="column is-4" v-if="summaryData.tare_mass">
          <b-field label="Tare Mass">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.tare_mass"
              readonly
            ></b-input>
          </b-field>
        </div>

        <div class="column is-4" v-if="summaryData.net_mass">
          <b-field label="Net Mass">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.net_mass"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!--Container Identification Number-->
        <div class="column is-4" v-if="summaryData.container_identification_number">
          <b-field label="Container Identification Number">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.container_identification_number"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!--Seal Number-->
        <div class="column is-4" v-if="summaryData.seal_number">
          <b-field label="Seal Number">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.seal_number"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!--Container Type-->
        <div class="column is-4" v-if="summaryData.container_type">
          <b-field label="Container Type">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.container_type"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!--Container Operator-->
        <div class="column is-4" v-if="summaryData.container_operator">
          <b-field label="Container Operator">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.container_operator"
              readonly
            ></b-input>
          </b-field>
        </div>

        <!--Container Size-->
        <div class="column is-4" v-if="summaryData.container_size">
          <b-field label="Container Size">
            <b-input
              custom-class="has-text-weight-bold is-uppercase"
              v-model="summaryData.container_size"
              readonly
            ></b-input>
          </b-field>
        </div>
      </div>

      <!-- Dangerous Goods Packaging -->
      <dangerous-good-packaging :data="dangerousGoodPackaging"></dangerous-good-packaging>
    </div>
  </div>
</template>

<script>
import dangerousGoodPackaging from "./DangerousGoodPackaging";
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapGetters } = createNamespacedHelpers("shippers");

export default {
  name: "dangerousGood",
  components: { dangerousGoodPackaging },
  props: {
    data: Object
  },
  data() {
    return {
      marinePollutant: this.data.marine_pollutant ? "YES" : "NO",
      temperatureControlled: this.data.temperature_controlled ? "YES" : "NO",
      limitedQuantity: this.data.limited_quantity ? "YES" : "NO",
    };
  },
  computed: {
    ...mapGetters({
      dangerousGoodsInfo: "getDangerousGoodsInfo"
    }),
    dangerousGoodPackaging: function() {
      return this.data.dangerous_good_packaging;
    },

    summaryData: function(){
      if(this.data){
      return this.data
      }
    },
    selectedDangerousGoodInfo() {
      if (this.dangerousGoodsInfo) {
        return this.dangerousGoodsInfo.find(dgInfo => {
          return dgInfo.id === this.summaryData.dangerous_good_info_id;
        });
      }

      return null;
    }
  }
};
</script>
